/**
 * Ryan O'Dowd
 * 2024-12-02
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({safeAreaInsets}) => {
  return {
    container: {
      flex: 1,
      margin: 0,
      padding: 0,
    },
    contentContainer: {
      gap: 4,
      paddingBottom: safeAreaInsets.bottom,
    },
  };
};

export default getStyles;
